import {ReloadButton} from '@flexinet/ui-components';

import {Box} from '@mantine/core';

import {useQueryClient} from '@tanstack/react-query';

import {reportTypesKeys} from '../hooks/useReportTypesQuery';

/**
 * FNP-918: Reload invalidates the list key.
 *
 * It previously called `useReportTypes().fetchRecords()`, which mounted an
 * entire second copy of the list query inside the page header just to reach an
 * invalidate call — a duplicate fetch on every render of a button. Taking the
 * query client directly does the same job with no query attached.
 *
 * This button carries more weight here than elsewhere: the catalogue query sets
 * a five-minute `staleTime`, so Reload is the operator's way to pull a
 * Stripe-side addition in before that expires.
 */
export const ReloadRecordsButton = () => {

    const queryClient = useQueryClient();

    return (
        <Box mx='s'>
            <ReloadButton
                onClick={() => queryClient.invalidateQueries({
                    queryKey: reportTypesKeys.all,
                })}
            />
        </Box>
    );
};
